var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24511 1.04454L1.24512 1.04453C1.33102 0.958625 1.47031 0.958625 1.55621 1.04453L1.55622 1.04454L6.35622 5.84454C6.39748 5.8858 6.42066 5.94176 6.42066 6.00011C6.42066 6.05846 6.39748 6.11442 6.35623 6.15567C6.35622 6.15568 6.35622 6.15568 6.35622 6.15568L1.55623 10.9556L1.55615 10.9557C1.47026 11.0416 1.33107 11.0416 1.24518 10.9557L1.24507 10.9556C1.1592 10.8697 1.1592 10.7305 1.24506 10.6447L1.24511 10.6446L5.53599 6.35366L5.88953 6.00011L5.53598 5.64656L1.24511 1.35568C1.15918 1.26976 1.15918 1.13047 1.24511 1.04454Z",
    fill: "#09090B",
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.1de79d078f4c050c5b1d8ada8935d3ef.svg";
export { ForwardRef as ReactComponent };